import TableCell, { TTableCellProps } from "./TableCell"
import { TTableRow } from "./TableConst"

export type TTRProps<T extends TTableRow> = React.ComponentPropsWithoutRef<"tr">|( (row:T) => React.ComponentPropsWithoutRef<"tr"> )
export type TTableRowProps<T extends TTableRow> = Omit<TTableCellProps<T>, "col"|"row"> & {
    row:T
    cols:string[]
    tr?:TTRProps<T>
}

export default function TableRow<T extends TTableRow>(props:TTableRowProps<T>){
    const trProps = props.tr instanceof Function ? props.tr(props.row) : (props.tr || {})
    const cells = props.cols.map(col => <TableCell row={props.row} col={col} td={props.td} cellValue={props.cellValue} cellText={props.cellText} key={col}/>)
    return <tr {...trProps}>{cells}</tr>
}
